import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    connect() {
        const bars = this.element.querySelectorAll(".grade-bar")
        // we can't scale height of bars by inline-style, so we need to set it via js
        bars.forEach((bar: HTMLElement) => {
            bar.style.height = bar.style.minHeight = bar.dataset.height
        })
    }
}
